import { Link } from "react-router-dom";

export type AgTechSideNavigationMenuItemProps = {
    text: string,
    icon?: string,
    link: string,
    isCollapsed: boolean,
    classes?: string,
    onSelected: (link: string) => void
}

const AgTechSideNavigationMenuItem = (props: AgTechSideNavigationMenuItemProps) => {
    const activeClass = window.location.pathname.endsWith(props.link) ? '!bg-highlight !text-white' : '';
    const collapsedClass = props.isCollapsed ? 'collapsed' : '';
    const customClasses = props.classes ?? '';

    return (
        <Link
            to={`/app${props.link}`}
            className={`column-based button button-link items-center py-[14px] px-[24px] h-[56px] leading-[56px] hover:text-highlight-300 rounded-sm text-more clickable text-appSideNavFont container ${activeClass} ${collapsedClass} ${customClasses}`}
            onClick={() => props.onSelected(props.link)}
        >
            {props.icon && (
                <i
                    className={`mr-6 w-[20px] min-w-[20px] max-w-[20px] text-plus ${props.icon} centered container`}
                    style={{ display: 'flex' }}
                    aria-hidden="true"
                />
            )}
            {props.isCollapsed ? null : props.text}
        </Link>
    )
}

export default AgTechSideNavigationMenuItem;